<template>
  <b-modal :title="title" :visible="true" @cancel="onClose" @close="onClose" ref="modal">
    <offline-indicator v-if="!loaded && !online" />

    <font-awesome-icon icon="spinner" spin size="3x" v-else-if="!loaded && loading"/>

    <div class="modal-select-factory" v-else>
      <b-input type="text" placeholder="Suchen" v-model="searchValue" autofocus/>

      <ul class="data-list">
        <li v-for="factory of pagination.data" :key="factory.id">
          <a href="#" @click.prevent="() => onSelect(factory)">
            {{ `${factory.fullName}` }}
          </a>
        </li>
      </ul>

      <b-pagination v-model="currentPage" :total-rows="pagination.items" :per-page="pagination.perPage" class="float-right"/>
    </div>
  </b-modal>
</template>

<script>
import {ref, computed, watch} from "@vue/composition-api";
import OfflineIndicator from "@/app/components/OfflineIndicator.vue";

export default {
  components: {OfflineIndicator},
  props: {
    title: {
      type: String,
      required: true,
    }
  },

  emits: [ 'select', 'cancel' ],

  setup(props, { emit }) {
    const store = window.useStore()

    const modal = ref(null)

    const online = computed(() => store.state.pwa.online)
    const loaded = computed(() => store.state.pwa.pigSty.lastFetched !== null)
    const loading = computed(() => store.getters['backgroundDataLoading'])

    const currentPage = ref(1)

    const searchValue = ref(null)

    const factories = computed(() => {
      if (!store.state.pwa.pigSty.data.length) {
        return []
      }
      return store.state.pwa.pigSty.data.reduce((res, item) => {
        res.push(item)
        return res
      }, [])
    })

    const searchResults = computed(() => {
      if (!searchValue.value) {
        return factories.value
      }
      const q = ('' + searchValue.value).toLowerCase()
      return factories.value.filter(factory =>
        factory.fullName.toLowerCase().includes(q))
    })

    const pagination = computed(() => {
      const itemsPerPage = 10
      const start = (currentPage.value - 1) * itemsPerPage
      return {
        perPage: itemsPerPage,
        items: searchResults.value.length,
        page: currentPage.value,
        maxPage: Math.ceil(searchResults.value.length / itemsPerPage),
        data: searchResults.value.slice(start, start + itemsPerPage),
      }
    })

    watch(searchValue, () => currentPage.value = 1)

    // give some time for fade out animation before removing from dom
    const onClose = () => setTimeout(() => emit('cancel'), 500)

    const onSelect = (factory) => {
      emit('select', factory)
      modal.value.hide()
      onClose()
    }

    return {
      modal,
      online,
      loaded,
      loading,
      searchValue,
      searchResults,
      pagination,
      currentPage,
      onClose,
      onSelect,
    }
  }
}
</script>

<style lang="scss">
.modal-select-factory {
  ul.data-list {
    list-style-type: none;
    margin: 30px 0;
    padding: 0;
  }
}
</style>
